import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d16669e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2d16669e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16669e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d16669e')) {
      api.createRecord('2d16669e', component.options)
    } else {
      api.reload('2d16669e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d16669e&scoped=true&", function () {
      api.rerender('2d16669e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/table/index.vue"
export default component.exports